import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import Bannerimage from "../../assets/images/BannerImage.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import GetInTouch from "../../components/button/GetInTouch";
import LandingImage from "../../assets/images/LandingImage.webp";
import MobileLandingImage from "../../assets/images/MobileLandingImg.png";
import DesignElement from "../../assets/images/DesignElement.png";

const LandingSection = () => {
  // Use the Material-UI theme and media query
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          top: "1rem",
          width: "100%",
          position: "relative",
        }}
      >
        {/* Conditionally render the image based on the screen size */}
        <LazyLoadImage
          src={isMobile ? MobileLandingImage : Bannerimage}
          effect="blur"
          width="100%"
          height="100%"
          style={{ marginTop: isMobile ? "80px" : isTablet ? "60px" : "0" }}
        />

        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "1440px" },
            margin: "0 auto",
          }}
        >
          <Box
            sx={{
              zIndex: 1,

              top: { xs: "6rem", sm: "7rem", lg: "10rem" },
              padding: { xs: "0rem 2rem", sm: "0rem 2rem" },
              position: "absolute",
            }}
          >
            {/* Design Element Image */}
            <Box
              sx={{
                position: "absolute",
                left: { xs: "-17rem", sm: "-27rem" },
                top: { xs: "-2rem", sm: "-3rem" },
                width: { xs: "25rem", sm: "42rem" },
                opacity: 0.8,
                zIndex: -1,
              }}
            >
              <LazyLoadImage
                src={DesignElement}
                effect="blur"
                width="100%"
                height="100%"
                alt="design element"
              />
            </Box>

            <Typography
              variant="h4"
              sx={{
                color: "rgba(255, 255, 255, 1)",
                fontSize: { xs: "1rem", sm: "1.4rem", md: "1.8rem" },
                fontFamily: "Montserrat",
                fontWeight: "700",
              }}
            >
              Advisory through <br />
              machine, human & artificial intelligence
            </Typography>

            <Typography
              sx={{
                color: "rgba(255, 255, 255, 1)",
                fontSize: { xs: "0.8rem", sm: "1.2rem" },
                margin: { xs: "1rem 0", sm: "1.5rem 0" },
                fontFamily: "Plus Jakarta Sans",
                maxWidth: "500px",
                fontWeight: "600",
                fontStyle: "italic",
              }}
            >
              Bringing clarity to a complex world
            </Typography>
            <GetInTouch />
          </Box>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: { xs: "18rem", sm: "16rem", lg: "8rem" },
            right: { xs: "0.5rem", sm: "3rem", xl: "8rem" },
            width: { xs: "15rem", sm: "21rem", lg: "34rem", xl: "32rem" },
          }}
        >
          <LazyLoadImage
            src={LandingImage}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LandingSection;
